/**
 * Task Lookup API — GET /task-lookup?q=<any code>[&task=<uid>]
 */
import api from './api';

export type TimelineSource = 'core_task' | 'core_item' | 'core_order' | 'app_tap' | 'fleet_api' | 'fleet_route';

export interface TimelineEvent {
  id: string;
  at: string; // ISO UTC
  source: TimelineSource;
  title: string;
  slug?: string;
  taskId?: number;
  actor?: { type: string; id?: string | number | null; name?: string | null };
  raw: unknown;
}

export interface LookupWarning {
  rule: string;
  severity: 'error' | 'warn';
  message: string;
  evidence: { eventIds: string[] };
}

export interface LookupResult {
  matches: { uid: string; platform_code: string; type: string; status: string; created_at: string }[];
  task: {
    id: number; uid: string; platform_code: string; type: string; status: string;
    driver_id: number | null; driver_name: string | null; name: string | null; merchant_name?: string | null;
  };
  item: { kind: string; code: string | null; uid: string; status: string } | null;
  route: { route_name: string; driver_name: string | null; sequence: number; stop_status: string; run_date: string | null } | null;
  warnings: LookupWarning[];
  timeline: TimelineEvent[];
  unavailable: { source: TimelineSource; error: string }[];
}

export class LookupError extends Error {
  status: number;
  constructor(status: number) {
    super(`lookup failed: ${status}`);
    this.status = status;
  }
}

export async function lookupTask(q: string, task?: string): Promise<LookupResult> {
  try {
    const res = await api.get<{ success: true; data: LookupResult }>('/task-lookup', { params: { q, task } });
    return res.data.data;
  } catch (err) {
    const status = (err as { response?: { status?: number } }).response?.status ?? 0;
    throw new LookupError(status);
  }
}
